// src/stores/receptions.js
import { ref } from "vue";
import { defineStore } from "pinia";
import apiClient from "@/axios";
import { useToast } from "vue-toastification";

export const useReceptionsStore = defineStore("receptions", () => {
  const receptionsList = ref([]);
  const loading = ref(false);
  const pagination = ref({
    total: 0,
    current_page: 1,
    per_page: 20,
    last_page: 1,
  });
  const searchQuery = ref("");
  const filters = ref([
    // مثال: { column: "City", operator: "LIKE", value: "تهران" }
  ]);
  const searchColumn = ref(["F_namefami", "Pmeli", "Ptele"]);
  const toast = useToast();
  async function fetchReceptions(page = pagination.value.current_page) {
    try {
      const requestBody = {
        filters: filters.value, //  اضافه کردن فیلترهای دلخواه
        page,
        perPage: pagination.value.per_page,
        search: searchQuery.value,
        searchColumn: searchColumn.value, // ستونی که می‌خوای جستجو بشه
        orderBy: "F_rid"
      };
      const response = await apiClient.post("/Reception/GetAllAsync", requestBody);

      if (response.data && Array.isArray(response.data.result)) {
        console.log(receptionsList.value);
        receptionsList.value = response.data.result;
        const total = response.data.totalCount || 0;
        pagination.value = {
          total: total,
          current_page: response.data.currentPage || page,
          per_page: response.data.perPage || 20,
          last_page: response.data.lastPage || 1
        };
        if (receptionsList.value.length === 0) {
          toast.info("برای تاریخ انتخاب شده ، هیچ نوبتی یافت نشد");
        }
      } else {
        console.error("Invalid API response:", response.data);
        receptionsList.value = [];
        toast.error("خطا در دریافت اطلاعات نوبت");
      }
    } catch (error) {
      console.error("Error fetching patients:", error);
      receptionsList.value = [];
      toast.error("خطا در ارتباط با سرور");
    }
  }
  async function addReception(receptionData) {
    try {
      const response = await apiClient.post('Reception/', receptionData);
      if (response.status === 200) {
        toast.success("نوبت با موفقیت ثبت شد");
        searchQuery.value = "";
        await fetchReceptions(1);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error adding doctor:", error);
    } finally {
      loading.value = false;
    }
  }

  async function batchAddReceptions(batchData) {
    try {
      await apiClient.post('Reception/CreateBatchReception', batchData);
      await fetchReceptions(1);
      toast.success(`${batchData.count} نوبت با موفقیت ایجاد شد.`);
    } catch (error) {
      console.error("Error adding batch receptions:", error);
    }
  }

  async function updateReception(data) {
    try {
      const response = await apiClient.put("/Reception", data);
      if (response.status === 200) {
        toast.success("اطلاعات نوبت دهی با موفقیت ویرایش شد");
        await fetchReceptions(pagination.value.current_page);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error updating reception:", error);
    }
  }

  async function deleteReception(id) {
    loading.value = true;
    try {
      const response = await apiClient.delete(`/Reception/${id}`);
      if (response.status === 200) {
        toast.success("نوبت با موفقیت حذف شد");
        await fetchReceptions(pagination.value.current_page);
      } else {
        toast.error("خطا در حذف نوبت");
      }
    } catch (error) {
      toast.error("خطا در حذف نوبت");
    } finally {
      loading.value = false;
    }
  }


  return {
    receptionsList,
    pagination,
    searchQuery,
    filters,
    fetchReceptions,
    addReception,
    batchAddReceptions,
    updateReception,
    deleteReception
  };
});
